import React, { useEffect } from "react";
import certificate_1 from "../assets/certificate_img_1.png";
import certificate_2 from "../assets/certificate_img_2.png";
import certificate_3 from "../assets/certificate_img_3.png";
import certificate_4 from "../assets/certificate_img_4.png";
import certificate_5 from "../assets/certificate_img_5.png";
import certificate_6 from "../assets/certificate_img_6.png";
import certificate_7 from "../assets/certificate_img_7.png";
import certificate_8 from "../assets/certificate_img_8.png";
import certificate_icon_1 from "../assets/certificate_icon_1.png";
import certificate_icon_2 from "../assets/certificate_icon_2.png";
import certificate_icon_3 from "../assets/certificate_icon_3.png";
import certificate_icon_4 from "../assets/certificate_icon_4.png";
import certificate_icon_5 from "../assets/certificate_icon_5.png";
import certificate_icon_6 from "../assets/certificate_icon_6.png";
import certificate_icon_7 from "../assets/certificate_icon_7.png";
import certificate_icon_8 from "../assets/certificate_icon_8.png";
const CertificationPage = () => {
  const certificates = [
    {
      id: "1",
      icon: certificate_icon_1,
      image: certificate_1,
      title: "Global Organic Textile Standard (GOTS)",
      description: ` Our organic cotton is GOTS certified, one of the highest standards
              for organic textiles. It means the fabric is made from pure
              organic fibers, with dyes and processes that are safe for you and
              the environment.`,
    },
    {
      id: "2",
      icon: certificate_icon_2,
      image: certificate_2,
      title: "Global Organic Latex Standard (GOLS)",
      description: `We use GOLS certified organic latex in our mattresses and pillows.
With over 95% organic content and no harmful chemicals, it offers a cleaner,
naturally resistant surface that keeps dust mites and allergens away.`,
    },
    {
      id: "3",
      icon: certificate_icon_3,
      image: certificate_3,
      title: "eco-INSTITUT",
      description: ` Our latex foam carries the eco-INSTITUT certification,
a trusted standard for safety and low emissions.
It assures that the material you sleep on is clean, non-toxic,
and made from 100% natural rubber.`,
    },
    {
      id: "4",
      icon: certificate_icon_4,
      image: certificate_4,
      title: "OEKO-TEX® STANDARD 100",
      description: ` The STANDARD 100 by OEKO-TEX certification is a globally
trusted benchmark for textile safety. Think of it as a gold standard
that ensures our natural latex is free from harmful
substances and safe for everyday use, even on sensitive skin.`,
    },
    {
      id: "5",
      icon: certificate_icon_5,
      image: certificate_5,
      title: "USDA Organic",
      description: ` Our organic latex and cotton are USDA Organic certified.
This means they are grown and processed without harmful chemicals,
following strict and sustainable farming practices.`,
    },
    {
      id: "6",
      icon: certificate_icon_6,
      image: certificate_6,
      title: "Sustainable Furnishings Council (SFC)",
      description: `As members of the Sustainable Furnishings Council, we follow
responsible practices across our processes.
Reflecting our commitment to responsible practices, balancing the needs
of people, the planet, and everything in between.`,
    },
    {
      id: "7",
      icon: certificate_icon_7,
      image: certificate_7,
      title: "Organic EU Certification",
      description: `Meeting strict European organic standards, our materials are free from
synthetic pesticides and fertilizers. It’s one more way we ensure that
what you bring home is clean, safe, and thoughtfully made`,
    },
    {
      id: "8",
      icon: certificate_icon_8,
      image: certificate_8,
      title: "Carbon Neutral Certified",
      description: `Our latex products are carbon-neutral certified.
This reflects our effort to reduce environmental impact at every step,
from how we make our products to how they reach
and live in your home..`,
    },
  ];

  useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, []);
  return (
    <div className="bg-[#ebf4eb] font-lexend text-center pt-28 md:pt-32 mx-auto w-full pb-10 xl:pb-36">
      <div className="w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[88rem] mx-auto px-4 md:px-2 gap-6 md:gap-8 ">
        <h1 className="text-[#333333] sm:text-4xl text-[52px] font-extralight">
          Certifications
        </h1>
        <p className="text-[#6d6d6d] sm:text-lg xs:text-sm text-xl font-light mt-4">
          At Moondew, every material we use is carefully chosen and verified.
        </p>
        <p className="text-[#6d6d6d] sm:text-lg xs:text-sm  text-xl font-light ">
          These certifications ensure that what touches your skin is safe,
          natural, and responsibly made for you and for the world around you.
        </p>
        {certificates.map((item, index) => {
          const isEven = index % 2 === 0;
          return (
            <div
              key={index}
              className="grid grid-cols-12  bg-[#ffffff] p-4 rounded-[22px] lg:gap-0 gap-6 lg:mt-12 mt-6 "
            >
              <div
                className={`lg:col-span-4 col-span-12 3xl:w-[435px] md:h-[345px] h-80 xs:h-64 overflow-hidden     order-3 
        ${isEven ? "lg:order-1" : "lg:order-3"} rounded-[22px]`}
                style={{
                  backgroundImage: `url(${item.image})`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
              ></div>
              <div className="lg:col-span-6 col-span-12 2xl:ps-8 3xl:pe-10 md:px-6 flex flex-col justify-center  order-2 lg:order-2 items-start">
                <h2 className="text-xl sm:text-lg xs:text-base leading-5 text-[#333333] font-semibold text-left">
                  {item.title}
                </h2>
                <p className="text-left leading-[26px] xs:text-sm  text-lg sm:text-base text-[#6d6d6d] mt-3">
                  {item.description}
                </p>
              </div>
              <div
                className={`lg:col-span-2 col-span-12 flex  justify-center order-1 
        ${isEven ? "lg:order-3" : "lg:order-1"} items-center`}
              >
                <img src={item.icon} alt="certificate_icon_1" />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CertificationPage;
